import React from "react";
import BoxComponent from "../../../components/Box/BoxComponent";
import ImageLogoComponent from "../../../components/Image/ImageLogoComponent";
import TextFieldComponent from "../../../components/TextField/TextFieldComponent";
import SelectComponent, { SelectOptionProps } from "../../../components/Select/SelectComponent";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import SearchIcon from "../../../assets/icons/search_icon.png";

interface CaixaSearchProps {
    descricao: string;
    formaPgto: string[];
    tipoOperacao: string[];

    onChangeDescricao: (value: string) => void;
    onChangeFormaPgto: (value: string[]) => void;
    onChangeTipoOperacao: (value: string[]) => void;

    optionsFormaPgto: SelectOptionProps[];
    optionsTipoOperacao: SelectOptionProps[];

    onClickSessoesAnteriores: () => void;
    onClickSuprimento: () => void;
    onClickSangria: () => void;
    onClickFecharCaixa: () => void;
}

const CaixaSearchComponent = (props: CaixaSearchProps) => {
    const handleChangeDescricao = (value: string) => {
        props.onChangeDescricao(value);
    }

    const handleChangeFormaPgto = (value: string[]) => {
        props.onChangeFormaPgto(value);
    }

    const handleChangeTipoOperacao = (value: string[]) => {
        props.onChangeTipoOperacao(value);
    }

    return <BoxComponent
        component="section"
        sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            padding: 2,
            gap: 1.6
        }}
    >
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                gap: 1.5
            }}
        >
            <BoxComponent
                component="article"
                sx={{
                    display: "flex",
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    borderRadius: "8px",
                    height: "41px",
                    border: "1px solid #E0E0E0",
                    gap: 2,
                    flex: 1
                }}
            >
                <ImageLogoComponent
                    sx={{
                        margin: 1.85,
                        width: 20,
                        height: 20
                    }}
                    src={SearchIcon}
                    alt="icone_pesquisa"
                />
                <TextFieldComponent
                    id="busca_caixa_descricao"
                    placeholder="Pesquise pela descrição"
                    variant="standard"
                    disableUnderline
                    fullWidth
                    value={props.descricao}
                    onInput={(e) => {
                        const target = e.target as HTMLInputElement;
                        handleChangeDescricao(target.value)
                    }}
                />
            </BoxComponent>
            <SelectComponent
                id="forma_pgto"
                value={props.formaPgto}
                onChange={(value) => handleChangeFormaPgto(value as string[])}
                label="Forma de pagamento"
                options={props.optionsFormaPgto}
                sx={{
                    // width: "15%",
                    height: "40px"
                }}
                sxForm={{
                    width: "15%",
                }}
                multiple
            />
            <SelectComponent
                id="tipo_operacao"
                value={props.tipoOperacao}
                onChange={(value) => handleChangeTipoOperacao(value as string[])}
                label="Tipo de operação"
                options={props.optionsTipoOperacao}
                sx={{
                    // width: "15%",
                    height: "40px",
                }}
                sxForm={{
                    width: "15%",
                }}
                multiple
            />
        </BoxComponent>
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
                width: "100%",
                gap: 1.5
            }}
        >
            <ButtonComponent
                id="caixas_anteriores"
                sx={{
                    height: "42px",
                    borderRadius: "8px",
                    px: "16px",
                    py: "8px",
                    border: "1px solid #FFB84D",
                    color: "#FF8C42",

                    fontFamily: '"Font 7", sans-serif',
                    fontWeight: 500,
                    fontSize: '16px',
                    lineHeight: '24px',
                    letterSpacing: '0em',
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    verticalAlign: 'middle'
                }}
                onClick={props.onClickSessoesAnteriores}
            >
                Caixas anteriores
            </ButtonComponent>
            <ButtonComponent id="suprimento"
                sx={{
                    height: "42px",
                    borderRadius: "8px",
                    px: "16px",
                    py: "8px",
                    border: "1px solid #FFB84D",
                    color: "#FF8C42",

                    fontFamily: '"Font 7", sans-serif',
                    fontWeight: 500,
                    fontSize: '16px',
                    lineHeight: '24px',
                    letterSpacing: '0em',
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    verticalAlign: 'middle'
                }}
                onClick={props.onClickSuprimento}
            >
                Suprimento
            </ButtonComponent>
            <ButtonComponent id="sangria"
                sx={{
                    height: "42px",
                    borderRadius: "8px",
                    px: "16px",
                    py: "8px",
                    border: "1px solid #FFB84D",
                    color: "#FF8C42",

                    fontFamily: '"Font 7", sans-serif',
                    fontWeight: 500,
                    fontSize: '16px',
                    lineHeight: '24px',
                    letterSpacing: '0em',
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    verticalAlign: 'middle'
                }}
                onClick={props.onClickSangria}
            >
                Sangria
            </ButtonComponent>
            <ButtonComponent id="fechar_caixa"
                sx={{
                    height: "42px",
                    borderRadius: "8px",
                    px: "16px",
                    py: "8px",
                    backgroundColor: "#FF8C42",
                    color: "#FFFFFF",

                    fontFamily: '"Font 7", sans-serif',
                    fontWeight: 600,
                    fontSize: '16px',
                    lineHeight: '24px',
                    letterSpacing: '0em',
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    verticalAlign: 'middle'
                }}
                onClick={props.onClickFecharCaixa}
            >
                Fechar caixa
            </ButtonComponent>
        </BoxComponent>
    </BoxComponent>
}

export default CaixaSearchComponent;